import { AutoIgnitionState } from 'console/device/types';
import { LegacyDevice } from 'console/device/device';
import { Capability } from 'console/device/device-capability';
import { deviceRequestAutoStart, deviceRequestEngineBlock, deviceRequestGuard, deviceRequestSiren, deviceRequestWebasto, } from 'console/redux/devices/items/actions';
export function isWebasto(state) {
    return [AutoIgnitionState.webasto, AutoIgnitionState['webasto-confirmed']].includes(state);
}
export function getVehicleGuardButton(device_id) {
    const onClick = (value) => deviceRequestGuard(device_id, value);
    const control_type = 'guard';
    return {
        control_type,
        onClick,
    };
}
export function getVehicleSimpleButton(device_id, control_type) {
    const onClick = (value) => {
        if (control_type === 'engine') {
            return deviceRequestEngineBlock(device_id, value);
        }
        if (control_type === 'webasto') {
            return deviceRequestWebasto(device_id, value);
        }
        return deviceRequestSiren(device_id, value);
    };
    return {
        onClick,
        control_type,
    };
}
export function getVehicleAutostartButton(device_id, duration) {
    const onClick = (autostart_command) => deviceRequestAutoStart(device_id, {
        state: autostart_command,
    });
    const control_type = 'autostart';
    return {
        onClick,
        duration,
        control_type,
    };
}
export function getVehicleControlsConfig(device) {
    const { id, capabilities, auto_ignition_duration } = device;
    const has_guard_button = LegacyDevice.has_capability(capabilities, Capability.has_guard_state);
    const has_engine_button = LegacyDevice.has_capability(capabilities, Capability.has_engine_block);
    const has_siren_button = LegacyDevice.has_capability(capabilities, Capability.has_siren_control);
    const has_autostart_button = LegacyDevice.has_capability(capabilities, Capability.has_autostart);
    const has_webasto_button = LegacyDevice.has_capability(capabilities, Capability.has_webasto);
    const guard_button = has_guard_button ? getVehicleGuardButton(id) : null;
    const engine_button = has_engine_button
        ? getVehicleSimpleButton(id, 'engine')
        : null;
    const webasto_button = has_webasto_button
        ? getVehicleSimpleButton(id, 'webasto')
        : null;
    const siren_button = has_siren_button ? getVehicleSimpleButton(id, 'siren') : null;
    const auto_ignition_button = has_autostart_button
        ? getVehicleAutostartButton(id, auto_ignition_duration)
        : null;
    const vehicle_controls = [
        guard_button,
        engine_button,
        webasto_button,
        auto_ignition_button,
        siren_button,
    ];
    const shared_vehicle_controls = vehicle_controls.map((control, index) => control
        ? {
            id: index,
            ...control,
        }
        : null);
    return shared_vehicle_controls;
}
